import { useMemo } from 'react';
import useCheckoutState from '../../../../hooks/useCheckoutState';
import isFieldEnabled from './isFieldEnabled';
import isFieldHidden from './isFieldHidden';
import { useGuestFields } from '../../../../contexts/GuestFieldsContext';

export default function useFieldVisibility(field) {
  const { isPreview, page, form, query } = useCheckoutState();
  const guest = useGuestFields();

  const enabled = useMemo(
    () =>
      guest
        ? isFieldEnabled({ ...field, _id: field.questionId }, guest.values, guest.questions)
        : isFieldEnabled(field, form.fields, page.fields),
    [field, form.fields, page.fields, guest],
  );

  // Only include field.hidden and field.required (not the full field object) to avoid recalculating when field.value changes during typing
  const hidden = useMemo(
    () => isFieldHidden(field, isPreview, query),
    [isPreview, field.hidden, field.required, query],
  );

  return {
    isPreview,
    enabled,
    hidden,
    shouldHideField: hidden || !enabled,
  };
}
